(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduceMotion) {
    const revealTargets = document.querySelectorAll('[data-reveal]');

    revealTargets.forEach((el) => {
      const idx = el.getAttribute('data-reveal-index');
      if (idx) el.style.setProperty('--reveal-index', idx);
    });

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -48px 0px' }
    );

    revealTargets.forEach((el) => io.observe(el));

    const tileObs = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-in');
            tileObs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -32px 0px' }
    );

    document.querySelectorAll('[data-lookbook-tile]').forEach((el) => tileObs.observe(el));

  }

  const params = new URLSearchParams(window.location.search);
  const category = params.get('category');
  if (category) {
    const categoryMap = {
      wedding: 'Wedding',
      eid: 'Eid',
      celebration: 'Private Celebration',
      corporate: 'Corporate',
    };
    const mapped = categoryMap[category.toLowerCase()];
    if (mapped) {
      const select = document.querySelector('[data-events-type-select]');
      if (select) select.value = mapped;
    }
  }
})();
